import { constants } from "../../../constants";

export default class GameHistory {
    constructor(gb) {
        Object.assign(this, { gb });
   }

    _default() {
        if (this.gb.queryParams.historyUrl) {
            window.open(this.gb.queryParams.historyUrl, "gamehistory", "scrollbars=1,height=600,width=760");
            this.gb.emitters.emit.web.gameHistory(true);
            return;
        }
        this.gb.emitters.emit.web.gameHistory();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.PNG:
                event["gameHistoryOpened"] = this._default;
                break;
            case constants.THUNDER:
                event["openexternalhistory"] = this._default;
                break;
            case constants.SYN:
                event["g2p.goToHistory"] = this._default;
                break;
            case constants.KAJ:
                event["game.goto.history"] = this._default;
                break;
            case constants.NLC:
                event["accountHistory"] = this._default;
                break;
            case constants.HBN:
                event["gotoHistory"] = this._default;
                break;
            case constants.GDR2:
                event["game.goto.history"] = this._default;
                break;
            default:
                event["openGameHistory"] = this._default;
        }

        return event;
    }
}
